// removed by extract-text-webpack-plugin
module.exports = {"container":"_-src-components-ErrorScreen-index---container---GxfwM","title":"_-src-components-ErrorScreen-index---title---1FwCw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorScreen/index.css
// module id = 630
// module chunks = 1